import { render, staticRenderFns } from "./Levelbar.vue?vue&type=template&id=5b281c5e&scoped=true"
import script from "./Levelbar.vue?vue&type=script&lang=js"
export * from "./Levelbar.vue?vue&type=script&lang=js"
import style0 from "./Levelbar.vue?vue&type=style&index=0&id=5b281c5e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b281c5e",
  null
  
)

export default component.exports